import { render, staticRenderFns } from "./SideProjects.vue?vue&type=template&id=44981854&"
import script from "./SideProjects.vue?vue&type=script&lang=js&"
export * from "./SideProjects.vue?vue&type=script&lang=js&"
import style0 from "./SideProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports